import { axios, baseURL } from '@/plugins/axios.js'
import { DirectUpload } from '@rails/activestorage'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCustomers(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/customers', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCustomer(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/customers/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createCustomer(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/customers', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateCustomer(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/customers/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removePhoto(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/customers/${params.id}/remove_photo`, {params})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCarBrands(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/variables/car_brands')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchComments(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/comments', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createComment(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/comments', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateComment(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/comments/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidComment(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/comments/${params.id}`, { params })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchCars(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/cars', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchWarranties(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/warranties', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTransactions(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/customers/${params.id}/transaction`, {params})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAnalytics(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/customers/${params.id}/analytics`, {params})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    directUploadCustomerPhoto(ctx, file) {
      return new Promise((resolve, reject) => {
        const url = `${baseURL}/direct_uploads?referer=customer_photo`
        const upload = new DirectUpload(file, url, {
          directUploadWillCreateBlobWithXHR: xhr => {
            const authHeaders = $cookies.get('userAuth')
            if (authHeaders) {
              xhr.setRequestHeader('access-token', authHeaders['access-token'])
              xhr.setRequestHeader('token-type', authHeaders['token-type'])
              xhr.setRequestHeader('client', authHeaders.client)
              xhr.setRequestHeader('expiry', authHeaders.expiry)
              xhr.setRequestHeader('uid', authHeaders.uid)
            }
          },
        })

        upload.create((error, blob) => {
          if (error) reject(error)
          else resolve(blob)
        })
      })
    },
  }
}